<template>
  <div class="carga-archivos">
    <div>
      <Titulo titulo="Carga de archivos" />
    </div>
    <b-row class="justify-content-center align-items-center">
      <b-col cols="12" md="10">
          <div class="mt-3 text-right">
            <img
              v-if="loading"
              class="loading"
              src="@/assets/images/loader.gif"
              alt
            />
            <!--b-button type="button" @click="limpiarInputReset" variant="outline-primary" :disabled="loading" class="ml-1">Limpiar</b-button-->
          </div>
          <br>
        <div class="mx-auto" v-if="!loading">
          <div class="text-justify">
            <h4 class="color-secundary mb-4" v-text="'Anexos de reclamación'"></h4>
            <hr>
          </div>
          <form @submit.prevent="cargue" id="cargue" style="padding-right: 70px" v-if="!loading">
            <b-form-file
              ref="archivo"
              required
              size="md"
              placeholder="Selecione un archivo"
              browse-text="Anexar"
              drop-placeholder="Suelte los archivos aqui...."
              :disabled="dataLength == 0 || loading"
              class="mt-2"
              :accept="tipo_archivo ? tipo_archivo : '.pdf'"
              :multiple="multiple ? multiple : false"
            >
              <!-- style="padding-right: 80px;" -->
              <template slot="file-name" slot-scope="{ names }">
                <b-badge v-if="names.length > 0" variant="dark" class="ml-1"
                  >{{ names[0] }} | {{ names.length }} Archivo(s)
                  seleccionado(s)</b-badge
                >
              </template>
            </b-form-file>

            <b-alert
              show
              dismissible
              fade
              variant="primary"
              v-if="uploadResponse"
              class="mt-4"
              @dismissed="showDismissibleAlertSuccess = false"
            >
              <div class="text-center titulo-alerta-succes">¡Alerta!</div>
              {{ uploadResponse.mensaje }}
              <ul>
                <li
                  v-for="(
                    value, prerequisito, index
                  ) in uploadResponse.prerequisitos"
                  :key="index"
                >
                  {{ prerequisito }}
                  <ul>
                    <li v-for="(_value, cargue, _index) in value" :key="_index">
                      {{ _value }}
                    </li>
                  </ul>
                </li>
              </ul>
            </b-alert>

            <b-alert
              show
              dismissible
              fade
              variant="danger"
              v-if="uploadRespnseError"
              class="mt-4"
              @dismissed="showDismissibleAlertError = false"
            >
              <div class="text-center titulo-alerta-danger">¡Alerta!</div>
              <ul>
                <li
                  v-for="(value, error, index) in uploadRespnseError"
                  :key="index"
                >
                  {{ error }}
                  <ul>
                    <li
                      v-for="(_value, archivo, _index) in value"
                      :key="_index"
                    >
                      {{ _value[0] }}
                    </li>
                  </ul>
                </li>
              </ul>
            </b-alert>

            <div class="mt-3 text-right">
              <img
                v-if="loading"
                class="loading"
                src="@/assets/images/loader.gif"
                alt
              />
              <!--b-button type="button" @click="limpiarInputReset" variant="outline-primary" :disabled="loading" class="ml-1">Limpiar</b-button-->
              <b-button
                type="submit"
                :disabled="dataLength == 0 || loading"
                class="ml-1 button-carga"
                >Enviar</b-button
              >
            </div>
          </form>
        </div>

        <div class="mx-auto" v-if="sending.length">
          <b-row>
            <b-col col sm="12" md="6" lg="4" class="pb-4">
              <b-form-select
                v-model="sendingType"
                :options="sendingTypeOpt"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              class="my-1"
              col
              sm="12"
              md="6"
              lg="4"
              v-for="(file, index) in sending_filtered"
              v-bind:key="index"
            >
              <b-card no-body>
                <b-card-body>
                  <b-row>
                    <b-col cols="2" class="p-0" style="font-size: 1.2rem">
                      <i class="fa fa-file-pdf-o mr-2" aria-hidden="true"></i>
                    </b-col>
                    <b-col
                      class="text-truncate p-0"
                      v-b-tooltip.hover
                      :title="file.name"
                    >
                      {{ file.name }}
                    </b-col>
                    <b-col cols="2" class="p-0">
                      <b-badge
                        variant="danger"
                        pill
                        v-b-toggle="'collapse' + index"
                        href="#"
                        class="ml-2 float-right"
                        v-if="file.error"
                        v-b-tooltip.hover
                        title="Clic para ver la causa del rechazo"
                      >
                        <i
                          class="fa fa-exclamation-circle mr-1"
                          aria-hidden="true"
                        ></i>
                        <span>{{ file.errors.length }}</span>
                      </b-badge>
                      <b-badge
                        variant="success"
                        pill
                        href="#"
                        v-if="file.success"
                      >
                        <i class="fa fa-check-circle"></i>
                      </b-badge>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="font-size: 0.9rem">
                      <b-collapse
                        :id="'collapse' + index"
                        v-if="file.errors.length"
                      >
                        <b-row
                          v-for="(error, index) in file.errors"
                          v-bind:key="index"
                        >
                          <b-col class="text-">
                            <em>
                              {{ error }}
                            </em>
                          </b-col>
                        </b-row>
                      </b-collapse>
                    </b-col>
                  </b-row>
                  <div>
                    <b-progress
                      height="1px"
                      :value="file.progress"
                      :max="100"
                      :variant="
                        file.error ? 'danger' : file.success ? 'success' : ''
                      "
                    ></b-progress>
                  </div>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </div>
        <div class="mx-auto" v-if="!loading">
          <table-component
            pagination
            @click-event="clickEvent"
            :data="dataPendientes"
            :dataLength="dataLength"
            :perPage="perPage"
          >
            <table-column
              slot="label"
              :label="'Cédula'"
              v-bind:value="'cedula'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Pagaré'"
              v-bind:value="'pagare'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Nombres'"
              v-bind:value="'nombre_cliente'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Estado'"
              v-bind:value="'estado'"
              :customClass="'text-center'"
            ></table-column>
          </table-component>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "AnexoReclamacion",
  data: () => {
    return {
      pagination:false,
      files: new FormData(),
      uploadResponse: null,
      uploadRespnseError: null,
      showDismissibleAlertSuccess: false,
      showDismissibleAlertError: false,
      recomendacion: "En este espacio podrás cargar la documentación requerida para la reclamación",
      tipo_archivo: "",
      multiple: true,
      perPage: 5,
      dataPendientes: [],
      dataLength: 0,
      sending: [],
      sendingType: null,
      sendingTypeOpt: [
        { value: null, text: "Filtrar archivos por", disabled: true },
        { value: "todos", text: "Todos" },
        { value: "buenos", text: "Buenos" },
        { value: "erroneos", text: "Erróneos" },
      ],
      end_consulta_anexos: false,
      envio_anexos: false,
    };
  },
  computed: {
    loading(){
      return this.end_consulta_anexos == true && this.envio_anexos == false ? false : true;
    },
    sending_filtered: function () {
      switch (this.sendingType) {
        case "erroneos":
          return this.sending.filter((sent) => sent.error == true);
          break;
        case "buenos":
          return this.sending.filter((sent) => sent.success == true);
          break;
        case "todos":
        default:
          return this.sending;
          break;
      }
    },
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
    Recomendaciones: () => import("@/containers/layout/Recomendaciones.vue"),
    BannerRight: () => import("@/containers/layout/banner-right.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  methods: {
    limpiarInputReset() {
      this.$refs.archivo.reset();
    },
    fileChange(fileList) {
      this.files.append(
        "cargues[]",
        this.$refs["archivo"].$refs.input.files[0]
      );
    },
    async cargue() {
      this.envio_anexos = true;

      const files = this.$refs["archivo"].$refs.input.files;

      // this.$store.commit("SET_LOADING", true);
      this.sending = [];
      for (var i = 0; i < files.length; i++) {
        this.sending[i] = {
          name: files[i].name,
          progress: 0,
          errors: [],
          success: false,
          error: false,
        };
      }

      let errorCounter = 0;
      let errorLimit = 10;

      for (var i = 0; i < files.length; i++) {
        let file_name = files[i].name.replace(".pdf", "");

        file_name = file_name.replace(".PDF", "");

        let requerido = this.dataPendientes.find((dato) => dato.pagare == file_name);

        let requerido_2 = this.dataPendientes.find((dato) => dato.cedula == file_name);

        let requerido_3 = this.dataPendientes.find((dato) => dato.pagare.replace("NG_", "") == file_name);

        if (requerido || requerido_2 || requerido_3) {
          this.files = new FormData();
          this.files.append("cargues[]", files[i]);

          try {
            let { data } = await this.$store.state.api.post(
              "/cargue_archivos_portal/pagos/portal",
              this.files,
              {
                onUploadProgress: (progressEvent) => {
                  var percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  );
                  this.$set(this.sending[i], "progress", percentCompleted);
                  this.sending.sort();
                },
              }
            );
            let response = data.archivos[0];

            if (response.guardado === true) {
              this.sending[i].success = true;
              this.sending.sort();
            } else {
              this.sending[i].error = true;
              errorCounter++;
              switch (typeof response.respuesta) {
                case "string":
                  this.sending[i].errors.push(response.respuesta);
                  break;
                case "object":
                  this.sending[i].errors = response.respuesta.nombre;
                  break;
              }

              this.sending.sort();
            }
          } catch (err) {
            this.sending[i].error = true;
            this.sending.sort();
            console.log(err);
          }

          if (errorCounter >= errorLimit) {
            if (
              confirm(
                "Se han producido " +
                  errorCounter +
                  " errores, desea detener el envío?"
              )
            ) {
              this.envio_anexos = false;
              return false;
            } else {
              errorLimit = errorLimit * 2;
            }
          }
        } else {
          this.sending[i].error = true;
          errorCounter++;
          this.sending[i].errors.push("El archivo adjunto no es requerido como soporte, ya que no se encuentra registrado en nuestra base de datos.");

          this.sending.sort();

          if (errorCounter >= errorLimit) {
            if (
              confirm(
                "Se han producido " +
                  errorCounter +
                  " errores, desea detener el envío?"
              )
            ) {
              this.envio_anexos = false;
              return false;
            } else {
              errorLimit = errorLimit * 2;
            }
          }
        }


      }
      this.sending.sort();

      this.envio_anexos = false;
      this.getPendientes(1);
    },
    async clickEvent(element, slug) {
      console.log(element, slug);
      if (slug == "paginacion") {
        this.getPendientes(element.page);
      }
    },
    async getPendientes(page = 1, paginar = "false") {
      this.end_consulta_anexos = false;
      try {
        let request = await this.$store.state.api.get("/informes/estado_pago", {
          params: {
            paginar,
            row: this.perPage,
            page,
          },
        });
        this.dataPendientes = request.data.datos;
        this.dataLength = request.data.paginacion.total;
        this.end_consulta_anexos = true;
      } catch (err) {
        this.end_consulta_anexos = true;
        this.$toasted.show(
          "Ocurrió un error intentando consultar los registros pendientes",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
      }
    },
  },
  mounted() {
    console.log('AnexosReclamacion');
    this.getPendientes(1);
  },
};
</script>
<style>
.card-body {
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.4s ease;
}

.card-body:hover {
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.custom-list-group {
  display: flex;
  width: 600px;
}

.custom-list-item {
  flex: 1;
}
</style>